<dialog #dialogRef class="dialog-element" [attr.aria-labelledby]="'dialog-headline'" [attr.aria-describedby]="'dialog-text'">
  <div class="dialog-container">
    <button class="dialog-close" type="button" (click)="onClose()" aria-label="Dialog schließen">
      <span class="close-text">Schließen</span>
      <svg class="close-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <div class="dialog-content">
      <h3 id="dialog-headline" class="h3">{{ headline }}</h3>
      <p id="dialog-text" class="big">{{ text }}</p>
    </div>
  </div>
</dialog>
